import {defineStore} from 'pinia'

// @ts-ignore
export const useMagazineStore = defineStore('magazine', {
  state: () => ({
    pathPrefix: '/magazine'
  }),
  getters: {},
  actions: {
    async getMagazineMain() {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/main`
      return await $apiClient(path, {
        method: 'GET'
      })
    },
    async getMagazinePrice() {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/price`
      return await $apiClient(path, {
        method: 'GET'
      })
    },
    async getMagazineDataBoardDetail(id) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/board/data/${id}`
      return await $apiClient(path, {
        method: 'GET'
      })
    },
    async getMagazineDataBoardDownload(id) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/board/data/${id}/download`
      return await $apiClient(path, {
        method: 'GET'
      })
    },
    async getMagazineDataBoardList(payload) {
      const {$apiClient} = useNuxtApp()
      const query = `?page=${payload.page}&limit=${payload.limit}&keyword=${payload.keyword}&type=${payload.type}&dataType=${payload.dataType}`
      const path = `${this.pathPrefix}/board/data${query}`
      return await $apiClient(path, {
        method: 'GET'
      })
    },
    async getMagazineMonthlyList(payload) {
      const {$apiClient} = useNuxtApp()
      const query = `?page=${payload.page}&limit=${payload.limit}&year=${payload.year}`
      const path = `${this.pathPrefix}/monthly${query}`
      return await $apiClient(path, {
        method: 'GET'
      })
    },
    async getMagazineMonthlyDetail(magazineId) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/monthly/${magazineId}`
      return await $apiClient(path, {
        method: 'GET'
      })
    },
    async getMagazineMonthlyDownload(magazineId) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/monthly/${magazineId}/download`
      return await $apiClient(path, {
        method: 'GET'
      })
    },
    async getHrKeywordList(payload) {
      const {$apiClient} = useNuxtApp()
      const query = `?page=${payload.page}&limit=${payload.limit}&consonant=${payload.consonant}&keyword=${payload.keyword}`
      const path = `${this.pathPrefix}/keyword/${payload.type}${query}`
      return await $apiClient(path, {
        method: 'GET'
      })
    }
  }
})
